import React, { useMemo, useState } from 'react';
import { useDeviceType } from 'contexts/ThemeContext/hooks/useDeviceType';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { AccountCircle, ExpandLess, ExpandMore } from '@mui/icons-material';
import { useSettingsModal } from 'contexts/SettingsModalContext/useSettingsModal';
import { LinkItem } from 'components/LinkItem/LinkItem';
import { SETTINGS_SECTION_IDS } from 'features/settings/types/types';
import { ListItem, styled } from '@mui/material';
import { DesktopManageAccountContent } from './DesktopManageAccountContent';

const Container = styled(ListItem)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
}));

export const ManageAccount = () => {
  const [manageAccountOpen, setManageAccountOpen] = useState(false);
  const { isDesktop } = useDeviceType();
  const { translation } = useTranslationContext();
  const { openModal } = useSettingsModal();

  const renderChevron = useMemo(() => {
    if (!isDesktop) {
      return null; // No chevron on mobile
    }
    return manageAccountOpen ? <ExpandLess /> : <ExpandMore />;
  }, [isDesktop, manageAccountOpen]);

  const handleClick = () =>
    isDesktop
      ? setManageAccountOpen((prev) => !prev)
      : openModal(SETTINGS_SECTION_IDS.ACCOUNT, translation('manage_account_capitalized'));

  return (
    <Container disableGutters disablePadding>
      <LinkItem
        showLinkIcon={false}
        leftIcon={<AccountCircle color="secondary" />}
        onClick={handleClick}
        rightIcon={renderChevron}
        isButton
      >
        {translation('manage_account_capitalized')}
      </LinkItem>
      {isDesktop && <DesktopManageAccountContent isOpen={manageAccountOpen} />}
    </Container>
  );
};
